<section class="clic-news__head hero-bar"></section>

<app-store-summary-bar [balance]="walletValue" [debit]="valueOfDebit" [cartCount]="cartCount"
  [loading]="!walletLoaded" [unknown]="walletUnknown" (openCart)="openCart()"></app-store-summary-bar>

<section class="store-container">
  <header class="store-head">
    <div class="store-head__intro">
      <h1 class="store-head__title">{{ 'clicStore.storeTitle' | translate }}</h1>
      <p class="store-head__subtitle">{{ 'clicStore.storeSubtitle' | translate }}</p>
    </div>

    <app-store-filters [term]="searchTerm" [sort]="sort" [categories]="categories"
      [selectedCategoryKey]="selectedCategoryKey" [totalCount]="visibleProducts.length"
      (termChange)="onSearchTermChange($event)" (sortChange)="onSortChange($event)"
      (categoryChange)="onCategoryChange($event)"></app-store-filters>
  </header>

  <p class="store-empty" *ngIf="visibleProducts.length === 0 && allProducts.length > 0">
    {{ 'clicStore.noResults' | translate }}
    <button type="button" class="store-empty__clear" *ngIf="hasFilters" (click)="clearFilters()">
      {{ 'clicStore.clearFilters' | translate }}
    </button>
  </p>

  <div class="store-grid">
    <app-store-product-card *ngFor="let product of visibleProducts; trackBy: trackByAwardId"
      [product]="product" [quantity]="quantityOf(product)" [remainingBalance]="valueAfterDebit"
      [balanceLoaded]="walletLoaded && !walletUnknown" (add)="increaseQuantity(product)"
      (increment)="increaseQuantity(product)" (decrement)="decreaseQuantity(product)">
    </app-store-product-card>
  </div>

  <p class="store-end" *ngIf="visibleProducts.length > 0">
    {{ (hasFilters ? 'clicStore.endOfFilteredList' : 'clicStore.endOfList')
       | translate:{ count: visibleProducts.length } }}
  </p>
</section>

<app-store-cart-drawer [open]="isCartOpen" [items]="cartItems" [balance]="walletValue"
  [submitting]="submitting" [phone]="deliveryPhone" [balanceUnknown]="walletUnknown"
  (closed)="closeCart()"
  (increment)="incrementInCart($event)" (decrement)="decrementInCart($event)"
  (removed)="removeFromCart($event)" (phoneChange)="deliveryPhone = $event"
  (confirmed)="onCreateBuyMovMutation()"></app-store-cart-drawer>

<app-store-exchange-success [open]="isSuccessOpen" [items]="successItems"
  [pointsSpent]="successPoints" [newBalance]="walletValue" [balanceLoading]="!walletLoaded" [balanceUnknown]="walletUnknown"
  [protocol]="successProtocol" (backToStore)="closeSuccess()"
  (goToStatement)="goToStatement()"></app-store-exchange-success>
